var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7498 23.0374H16.7498L11.1872 26.7374C10.3622 27.2874 9.24976 26.6999 9.24976 25.6999V23.0374C5.49976 23.0374 2.99976 20.5374 2.99976 16.7874V9.28735C2.99976 5.53735 5.49976 3.03735 9.24976 3.03735H21.7498C25.4998 3.03735 27.9998 5.53735 27.9998 9.28735V16.7874C27.9998 20.5374 25.4998 23.0374 21.7498 23.0374Z",
    stroke: "#38F2E4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 14.2V13.9376C15.5 13.0876 16.025 12.6375 16.55 12.275C17.0625 11.925 17.575 11.4751 17.575 10.6501C17.575 9.50005 16.65 8.57501 15.5 8.57501C14.35 8.57501 13.425 9.50005 13.425 10.6501",
    stroke: "#38F2E4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4946 17.1874H15.5059",
    stroke: "#38F2E4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageQuestion);
export default __webpack_public_path__ + "static/media/message-question.8806c34f78434d73ff187e8372ef1d23.svg";
export { ForwardRef as ReactComponent };